import { visitorTypes } from '../Domains/visitorTypes';
import { messagePermissions } from './messagePermissions';
import { payments } from './payments';

export class IBranch {
    _id                             : string;
    name                            : string;
    address                         : string;
    phone                           : string;
    status                          : string;
    contactPerson                   : string;
    type                            : string;
    contactPersonEmail              : string;
    company                         : string;
    appPassword                     : string;
    starttime                       : Date;
    endtime                         : Date;
    createdBy                       : string;
    gymPackage                      : string;
    modifiedBy                      : string;
    domain                          : string;
    isWhatsappEnabled               : boolean;
    isSmsEnabled                    : boolean;
    businessRule                    : boolean;
    visitorFee                      : string;
    shortAddress                    : string;
    whatsapp                        : string;
    whatsappCommunityInvitationLink : string;
    feeWhatsapp                     : string;
    visitorWhatsapp                 : string;
    registrationWhatsapp            : string;
    lockDefaulterOnACT              : boolean;
    generalTaxSettings              : GeneralTaxSettings;
    visitorTypes                    : visitorTypes;
    messagesPermission              : messagePermissions;
    payments                        : payments;
    termsAndConditions?             : string;
    invoiceData: {
        name: { type: String, trim: true },
        bannerImage: [{
            image: { type: String, trim: true },
        }
        ],
        address: { type: String, trim: true },
        contact: [{
            contactNumber: { type: String, trim: true },
        }
        ],
        showAddedBy:  boolean,
    }
    reportPrintData: {
        name: { type: String, trim: true },
        bannerImage: [{
            image: { type: String, trim: true },
        }
        ],
        address: { type: String, trim: true },
        contact: [{
            contactNumber: { type: String, trim: true },
        }
        ],
    }
    companyDetails: {
        bannerImage: {
            image: { type: String, trim: true },
        }
    }
}

class GeneralTaxSettings {
    isTaxOnPayout: boolean;
    payoutTaxOnRate: number;
}